import "./style/index.scss";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { useEffect, useRef } from "react";
import { setIdEmpresaPermissao, setSubTitle, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { Button, Col, Form, Row, Select, Image, DatePicker, DatePickerProps, Modal, Tag, Popover, Tooltip, Flex, Typography } from "antd";
import * as Icon from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { buscarEmpresa } from "../../services/empresaService";
import { listarSorteio } from "../../services/sorteioService";
import { DetalhesSorteioModel } from "../../models/sorteio/detalhesSorteioModel";
import { useReactToPrint } from "react-to-print";
import CadastroNotasFiscais from "./modals/cadastrar";
import { deletarNotasFiscais, listarNotasFiscais } from "../../services/notasFiscaisService";
import { NotasFiscaisModel } from "../../models/notasFiscais/notasFiscaisModel";
import { formatCPFCNPJ } from "../../util/formats";
import { currencyBRL } from "../../util/dinheiroBRAuxiliar";
import React from "react";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import { buscarConsignatario } from "../../services/consiganatarioService";
import { ConsignatarioModel } from "../../models/consignatario/consignatarioModel";
import { FilePdf } from "phosphor-react";
import { setBuscaNotasFiscais, setEntityNotasFiscais, setModalCadastrarNotasFiscais, setModalDeletarNotasFiscais } from "../../redux/slices/notasfiscais/notasFiscaisSlice";
import { BuscarNotasFiscaisModel } from "../../models/notasFiscais/buscarNotasFiscaisModel";
import { BuscaConsignatarioModel } from "../../models/consignatario/chamadas/buscaConsignatarioModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

dayjs.locale("pt-br");

type TipoArquivoAnexoModel = {
  id: number;
  descricao: string;
};

const tipoArquivoAnexoList = [
  { id: 5, descricao: "Entidade" },
  { id: 4, descricao: "Capitalização" },
];

const NotasFiscais = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const notasFiscaisState = useAppSelector((state) => state.notasFiscais);
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const relatorioNotasFiscais = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(setTitle("NOTAS FISCAIS DOS CONSIGNATÁRIOS"));
    dispatch(setSubTitle("CONSIGNATÁRIOS / ENVIO DE NOTAS FISCAIS DOS CONSIGNATÁRIOS"));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (persistedState.user.empresa !== null) {
      form.setFieldsValue({
        idEmpresa: persistedState.user.empresa.idEmpresa,
      });
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
  }, []);

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    form.resetFields(["idSorteio", "idTipoArquivoAnexo", "dataInicio", "dataFim"]);

    let busca: BuscarNotasFiscaisModel = { ...notasFiscaisState.busca, idEmpresa: value, idSorteio: null, dataInicio: null, dataFim: null, idTipoArquivoAnexo: null };

    let buscaConsignatario: BuscaConsignatarioModel = { ...consignatarioState.busca, idEmpresa: value };

    dispatch(setBuscaNotasFiscais(busca));
    dispatch(listarSorteio(value.toString()));
    dispatch(buscarConsignatario(buscaConsignatario));
    dispatch(listarNotasFiscais(busca));
  };

  const onChangeSorteio = (value: number) => {
    let busca: BuscarNotasFiscaisModel = { ...notasFiscaisState.busca, idSorteio: value };

    dispatch(setBuscaNotasFiscais(busca));
    dispatch(listarNotasFiscais(busca));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarNotasFiscaisModel = { ...notasFiscaisState.busca, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaNotasFiscais(busca));
    dispatch(listarNotasFiscais(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarNotasFiscaisModel = { ...notasFiscaisState.busca, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaNotasFiscais(busca));
    dispatch(listarNotasFiscais(busca));
  };

  const onChangeTipoArquivo = (value: number) => {
    let busca: BuscarNotasFiscaisModel = { ...notasFiscaisState.busca, idTipoArquivoAnexo: value };

    dispatch(setBuscaNotasFiscais(busca));
    dispatch(listarNotasFiscais(busca));
  };

  const goCadastrar = () => {
    dispatch(setEntityNotasFiscais({}));
    dispatch(setModalCadastrarNotasFiscais(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarNotasFiscais(false));
  };

  const goDeletar = (value: NotasFiscaisModel) => {
    dispatch(setEntityNotasFiscais(value));
    dispatch(setModalDeletarNotasFiscais(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarNotasFiscais(false));
  };

  const handlePrint = useReactToPrint({
    content: () => relatorioNotasFiscais.current,
  });

  const atualizar = () => {
    dispatch(listarNotasFiscais(notasFiscaisState.busca));
  };

  const handleExcel = () => {
    var data: any[] = [];

    data.push({
      "Filtro Empresa": empresaState.list.filter((a: EmpresaModel) => a.id === notasFiscaisState.busca.idEmpresa)[0]?.apelido,
    });

    if (notasFiscaisState.busca.idSorteio !== null) {
      data.push({
        "Filtro Empresa": "Filtro Sorteio",
      });
      data.push({
        "Filtro Empresa": dayjs(sorteioState.listSorteioEmpresas.filter((a: DetalhesSorteioModel) => a.idSorteio === notasFiscaisState.busca.idSorteio)[0]?.dataSorteio).format("DD/MM/YYYY"),
      });
    }

    if (notasFiscaisState.busca.dataInicio !== null) {
      data.push({
        "Filtro Empresa": "Filtro Data Inicial",
      });
      data.push({
        "Filtro Empresa": dayjs(notasFiscaisState.busca.dataInicio).format("DD/MM/YYYY"),
      });
    }

    if (notasFiscaisState.busca.dataFim !== null) {
      data.push({
        "Filtro Empresa": "Filtro Data Final",
      });
      data.push({
        "Filtro Empresa": dayjs(notasFiscaisState.busca.dataFim).format("DD/MM/YYYY"),
      });
    }

    if (notasFiscaisState.busca.idTipoArquivoAnexo !== null) {
      data.push({
        "Filtro Empresa": "Filtro Tipo",
      });
      data.push({
        "Filtro Empresa": notasFiscaisState.busca.idTipoArquivoAnexo === 4 ? "Capitalização" : "Entidade",
      });
    }

    data.push({
      "Filtro Empresa": "Emissão",
      "": "Sorteio",
      " ": "Razão Social",
      "  ": "CNPJ",
      "   ": "Consignatários",
      "    ": "Tipo",
      "     ": "Valor",
      "      ": "NF",
    });

    notasFiscaisState.list.forEach((item: NotasFiscaisModel) => {
      data.push({
        "Filtro Empresa": item.dataTransacao === null ? <></> : dayjs(item.dataTransacao).format("DD/MM/YYYY"),
        "": item.sorteio === null ? <></> : dayjs(item.sorteio).format("DD/MM/YYYY"),
        " ": item.razaoSocial,
        "  ": item.cpfcnpj === null ? <></> : formatCPFCNPJ(item.cpfcnpj),
        "   ":
          item.idsConsignatariosAssociados !== null
            ? consignatarioState.list
                .filter((a: ConsignatarioModel) => item.idsConsignatariosAssociados!.includes(a.id))
                .map((a: ConsignatarioModel) => a.apelido)
                .join(", ")
            : "",
        "    ": item.denominacaoTipo,
        "     ": item.valor === null ? <></> : currencyBRL(item.valor),
        "      ": item.numeroNotaFiscal,
      });
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "NotasFiscaisConsignatários.xlsx");
  };

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <div ref={ref} className="relatorios-html-format">
        <div className="rel-cabecalho">
          <div className="rel-titulo" style={{ display: "flex", flexDirection: "column" }}>
            <h2>
              <strong>Notas Fiscais dos Consignatários</strong>
            </h2>
            <h3>Consignatários / Envio de Notas Fiscais dos Consignatários</h3>
          </div>
          <hr />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p>{"Empresa: " + empresaState.list.filter((a: EmpresaModel) => a.id === notasFiscaisState.busca.idEmpresa)[0]?.apelido + ";"}</p>
            <p>
              {notasFiscaisState.busca.idSorteio !== null
                ? "Sorteio: " +
                  dayjs(sorteioState.listSorteioEmpresas.filter((a: DetalhesSorteioModel) => a.idSorteio === notasFiscaisState.busca.idSorteio)[0]?.dataSorteio).format("DD/MM/YYYY") +
                  ";"
                : ""}
            </p>
            <p style={notasFiscaisState.busca.idSorteio === null ? { marginTop: -10 } : {}}>
              {notasFiscaisState.busca.dataInicio !== null && notasFiscaisState.busca.dataFim !== null
                ? "Data: " + dayjs(notasFiscaisState.busca.dataInicio).format("DD/MM/YYYY") + " " + "até " + dayjs(notasFiscaisState.busca.dataFim).format("DD/MM/YYYY") + ";"
                : ""}
            </p>
            <p>{notasFiscaisState.busca.idTipoArquivoAnexo !== null ? (notasFiscaisState.busca.idTipoArquivoAnexo === 4 ? "Tipo: Capitalização" : "Tipo: Entidade" + ";") : ""}</p>
          </div>
        </div>
        <div className="rel-detalhes">
          <table className="tb-dados">
            <thead>
              <tr className="header-table">
                <th className="ht-center">Emissão</th>
                <th className="ht-center">Sorteio</th>
                <th className="ht-left">Razão Social</th>
                <th className="ht-right">CNPJ</th>
                <th className="ht-left">Consignatários</th>
                <th className="ht-left">Tipo</th>
                <th className="ht-right">Valor</th>
                <th className="ht-right">NF</th>
              </tr>
            </thead>
            <tbody className="body-table">
              {notasFiscaisState.list.map((t: NotasFiscaisModel) => {
                return (
                  <React.Fragment key={t.id}>
                    <tr>
                      <td className="ht-cemter">{t.dataTransacao === null ? <></> : dayjs(t.dataTransacao).format("DD/MM/YYYY")}</td>
                      <td className="ht-cemter">{t.sorteio === null ? <></> : dayjs(t.sorteio).format("DD/MM/YYYY")}</td>
                      <td className="ht-left">{t.razaoSocial}</td>
                      <td className="ht-right">{t.cpfcnpj === null ? <></> : formatCPFCNPJ(t.cpfcnpj)}</td>
                      <td className="ht-left">
                        {t.idsConsignatariosAssociados !== null
                          ? consignatarioState.list
                              .filter((a: ConsignatarioModel) => t.idsConsignatariosAssociados!.includes(a.id))
                              .map((a: ConsignatarioModel) => a.apelido)
                              .join(", ")
                          : ""}
                      </td>
                      <td className="ht-left">{t.denominacaoTipo}</td>
                      <td className="ht-right">{t.valor === null ? <></> : currencyBRL(t.valor)}</td>
                      <td className="ht-right">{t.numeroNotaFiscal}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  });

  const myContent = (caminhoArquivo: string, extensaoArquivo: string, nome: string) => (
    <div>
      {extensaoArquivo === "pdf" ? (
        <div style={{ justifyContent: "center", display: "flex", alignItems: "center", flexDirection: "column" }}>
          <div style={{ justifyContent: "center", alignContent: "center" }}>
            <FilePdf size={48} style={{ cursor: "pointer" }} onClick={() => window.open(caminhoArquivo)} />
          </div>
          <div>
            <a href="#" onClick={() => window.open(caminhoArquivo)}>
              {nome}
            </a>
          </div>
        </div>
      ) : (
        <Image width={200} src={caminhoArquivo} />
      )}
    </div>
  );

  const items: ItemMenuAcoes[] = [
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<NotasFiscaisModel> = [
    {
      title: "EMISSÃO",
      dataIndex: "dataTransacao",
      align: "center",
      render: (_, record) => <>{record.dataTransacao && dayjs(record.dataTransacao).format("DD/MM/YYYY")}</>,
    },
    {
      title: "SORTEIO",
      dataIndex: "sorteio",
      align: "center",
      render: (_, record) => <>{record.sorteio && dayjs(record.sorteio).format("DD/MM/YYYY")}</>,
    },
    {
      title: "RAZÃO SOCIAL",
      dataIndex: "razaoSocial",
      render: (_, record) => (
        <Typography.Text style={{ width: 300 }} ellipsis={{ tooltip: record.razaoSocial }}>
          {record.razaoSocial}
        </Typography.Text>
      ),
    },
    {
      title: "CNPJ",
      dataIndex: "cpfcnpj",
      align: "right",
      render: (_, record) => <>{record.cpfcnpj && formatCPFCNPJ(record.cpfcnpj)}</>,
    },
    {
      title: "CONSIGNATÁRIOS",
      dataIndex: "idsConsignatariosAssociados",
      width: 300,
      render: (_, record) => {
        //to-do: transformar em componente
        const maxTagCount = 2;
        const associatedConsignatarios = consignatarioState.list
          .filter((a: ConsignatarioModel) => record.idsConsignatariosAssociados?.includes(a.id))
          .map((a: ConsignatarioModel) => ({ label: a.apelido }));

        const displayedTags = associatedConsignatarios.slice(0, maxTagCount);
        const omittedTags = associatedConsignatarios.slice(maxTagCount);

        return (
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
            {displayedTags.map((item, index) => (
              <Tag style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.label}</Tag>
            ))}
            {omittedTags.length > 0 && (
              <Tooltip
                styles={{ root: { pointerEvents: "none" } }}
                title={
                  <ul style={{ paddingLeft: 16, margin: 0 }}>
                    {omittedTags.map((item, index) => (
                      <li key={index}>{item.label}</li>
                    ))}
                  </ul>
                }
              >
                <Tag>{`+ ${omittedTags.length} ...`}</Tag>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      render: (_, record) => <>{record.valor && currencyBRL(record.valor)}</>,
    },
    {
      title: "TIPO",
      dataIndex: "denominacaoTipo",
      render: (_, record) => <Tag>{record.denominacaoTipo}</Tag>,
    },
    {
      title: "NF",
      dataIndex: "numeroNotaFiscal",
      align: "center",
      render: (_, record) =>
        record.caminhoArquivo !== null &&
        record.extensaoArquivo !== null &&
        record.nomeArquivo !== null && (
          <>
            <Popover title="Nota Fiscal" content={myContent(record.caminhoArquivo, record.extensaoArquivo, record.nomeArquivo)}>
              <Icon.PaperClipOutlined style={{ fontSize: "120%" }} />
            </Popover>
            <span>{record.numeroNotaFiscal}</span>
          </>
        ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form form={form} layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  name="idEmpresa"
                  label="Empresa"
                  rules={[
                    {
                      required: true,
                      message: "Selecione a empresa",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Data do sorteio" name="idSorteio">
                <Select
                  allowClear
                  style={{ width: 150 }}
                  loading={sorteioState.loadingEmpresas}
                  onChange={onChangeSorteio}
                  options={sorteioState.listSorteioEmpresas.map((a: DetalhesSorteioModel) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker allowClear placeholder="" onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker allowClear placeholder="" onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<Icon.PrinterOutlined />} onClick={handlePrint} disabled={notasFiscaisState.loading} />
              </Form.Item>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<Icon.FileExcelOutlined />} onClick={handleExcel} disabled={notasFiscaisState.loading} />
              </Form.Item>
              <ButtonComponent onClick={goCadastrar}>NOVO ENVIO</ButtonComponent>
            </Flex>
          </Col>
        </Row>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              <Form.Item label="Tipo" name="idTipoArquivoAnexo">
                <Select
                  allowClear
                  style={{ width: 150 }}
                  onChange={onChangeTipoArquivo}
                  options={tipoArquivoAnexoList.map((a: TipoArquivoAnexoModel) => ({
                    value: a.id,
                    label: a.descricao,
                  }))}
                />
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent columns={columns} loading={notasFiscaisState.loading} data={notasFiscaisState.list} />
      <Modal title="NOVO ENVIO DE NOTA FISCAL" centered width={905} open={notasFiscaisState.modalCadastrar} onCancel={closeModalCadastrar} footer={null} destroyOnHidden>
        <CadastroNotasFiscais
          idEmpresa={form.getFieldValue("idEmpresa") === undefined ? null : form.getFieldValue("idEmpresa").value}
          idSorteio={form.getFieldValue("idSorteio") === undefined ? null : form.getFieldValue("idSorteio")}
        />
      </Modal>
      <Modal title="DELETAR ENVIO DE NOTA FISCAL" centered width={350} open={notasFiscaisState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover a nota fiscal?"
          action={deletarNotasFiscais({ value: notasFiscaisState.entity.id, busca: notasFiscaisState.busca })}
          close={setModalDeletarNotasFiscais(false)}
        />
      </Modal>
      <div style={{ display: "none" }}>
        <RelatorioHtml ref={relatorioNotasFiscais} />
      </div>
    </Flex>
  );
};

export default NotasFiscais;
